module.exports = __webpack_public_path__ + "996768fc5713c1c3317c4c7b838b5c3b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-26.png
// module id = 117
// module chunks = 0